import React, {useMemo} from 'react';
import Chart from 'react-apexcharts';

function StatusDistribution() {
  const apiUsageData = useMemo(
    () => ({
      successful: 2790,
      failed: 2233,
    }),
    [],
  );

  const totalApiUsage = useMemo(
    () => apiUsageData.successful + apiUsageData.failed,
    [apiUsageData],
  );

  const series = useMemo(
    () => [apiUsageData.successful, apiUsageData.failed],
    [apiUsageData],
  );

  const chartOptions = {
    series: series,
    chart: {
      type: 'donut',
      width: 200,
      height: 200,
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '91%',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 3,
      colors: ['#FFFFFF'],
    },
    colors: ['#0C5350', '#B42318'],
    labels: ['Successful', 'Failed'],
    legend: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
  };

  const legendItems = [
    {
      label: 'Successful',
      value: ((apiUsageData.successful / totalApiUsage) * 100).toFixed(1),
      color: 'bg-[#006464]',
    },
    {
      label: 'Failed',
      value: ((apiUsageData.failed / totalApiUsage) * 100).toFixed(1),
      color: 'bg-[#C83737]',
    },
  ];

  return (
    <div className="bg-white h-full shadow-cards rounded-xl border-[0.5px] border-[#EFEFEF] md:pb-3">
      <div className="bg-[#F9F9F9] py-3 px-6 rounded-t-xl">
        <p className="font-medium text-sm xl:text-base text-deepBlue">
          Status Distribution
        </p>
      </div>

      <div className="flex flex-col md:flex-row md:justify-between h-[80%] border-[0.5px] border-transparent md:border-b-[#F2F2F2]">
        <div className="md:w-[50%] w-full py-4 flex items-center justify-center">
          <div className="relative flex justify-center items-center w-[200px] h-[200px]">
            <Chart
              options={chartOptions}
              series={chartOptions.series}
              type="donut"
              height={200}
            />
            <div className="absolute flex flex-col items-center w-fit">
              <span className="text-[6px] mb-1 xl:text-[9px] font-normal text-[#858DAA]">
                Total API Usage
              </span>
              <h1 className="font-semibold text-base xl:text-md text-deepBlue">
                {totalApiUsage.toLocaleString()}
              </h1>{' '}
            </div>
          </div>
        </div>

        <div className="md:w-[50%] w-full py-4 xl:py-0 px-6 border border-transparent border-t-[#f2f2f2] md:border-l-[#F2F2F2] flex items-center justify-center flex-col gap-4 font-inter">
          <div className="flex flex-col space-y-8 w-full">
            {legendItems.map(item => (
              <div
                key={item.label}
                className="flex items-center justify-between w-full"
              >
                <div className="flex items-center gap-1.5">
                  <span className={`w-2 h-2 rounded-full ${item.color}`}></span>
                  <span className="text-deepBlue text-sm font-normal capitalize">
                    {item.label}
                  </span>
                </div>
                <span className="text-sm text-[#858DAA] font-medium">
                  {item.value}%
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatusDistribution;
